import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Cookies } from '../../utils/utils';
import { STATIC_PATH } from '../../config';

const onClose = () => {
  let date = new Date();
  date.setDate(date.getDate() + 1);
  Cookies.set('_offerrum_tg_popup_shown_', 1, { path: '/', expires: date });
};

const onAlreadySubscribe = () => {
  let date = new Date();
  date.setFullYear(date.getFullYear() + 20);
  Cookies.set('_offerrum_tg_subscriber_', 1, { path: '/', expires: date });
};

const ModalTelegramSubscribe = ({ closeModal, lang }) => {
  return (
    <>
      <div className="tg-subscribe-modal">
        <button type="button" className="popup-close" onClick={e => closeModal(e, onClose)}>
          <i className="icon-cross-rounded" />
        </button>

        <h2 className="tg-subscribe-header">
          <FormattedHTMLMessage
            id="telegram_popup.title"
            defaultMessage="Subscribe to&nbsp;our Telegram channel"
            tag="span"
          />
        </h2>

        <ul className="tg-subscribe-list">
          <li className="tg-subscribe-list-item">
            <img
              className="tg-subscribe-icon"
              src={`${STATIC_PATH}/img/tg-popup/tg-icon-1.svg`}
              alt=""
            />
            <span className="tg-subscribe-list-text">
              <FormattedMessage id="telegram_popup.list.item1" defaultMessage="Contests" />
            </span>
          </li>

          <li className="tg-subscribe-list-item">
            <img
              className="tg-subscribe-icon"
              src={`${STATIC_PATH}/img/tg-popup/tg-icon-2.svg`}
              alt=""
            />
            <span className="tg-subscribe-list-text">
              <FormattedMessage id="telegram_popup.list.item2" defaultMessage="Topical offers" />
            </span>
          </li>

          <li className="tg-subscribe-list-item">
            <img
              className="tg-subscribe-icon"
              src={`${STATIC_PATH}/img/tg-popup/tg-icon-3.svg`}
              alt=""
            />
            <span className="tg-subscribe-list-text">
              <FormattedMessage
                id="telegram_popup.list.item3"
                defaultMessage="Profitable case studies"
              />
            </span>
          </li>

          <li className="tg-subscribe-list-item">
            <img
              className="tg-subscribe-icon"
              src={`${STATIC_PATH}/img/tg-popup/tg-icon-4.svg`}
              alt=""
            />
            <span className="tg-subscribe-list-text">
              <FormattedMessage id="telegram_popup.list.item4" defaultMessage="Useful articles" />
            </span>
          </li>
        </ul>

        <div className="tg-subscribe-image">
          <img
            src={`${STATIC_PATH}/img/tg-popup/tg-${lang}.jpg`}
            srcSet={`${STATIC_PATH}/img/tg-popup/tg-${lang}@2x.jpg 2x`}
            alt=""
          />
        </div>

        <div className="tg-subscribe-controls">
          <a
            href="https://t.me/offerrum_cpa"
            target="_blank"
            className="tg-subscribe-button btn btn-bold btn-primary not_subscribed"
          >
            <FormattedMessage id="telegram_popup.buttons.subscribe" defaultMessage="Subscribe" />
          </a>

          <button
            type="button"
            className="tg-subscribe-button btn btn-inline"
            onClick={e => closeModal(e, onAlreadySubscribe)}
          >
            <FormattedMessage
              id="telegram_popup.buttons.already_subscribed"
              defaultMessage="Already subscribed"
            />
          </button>
        </div>
      </div>
      <div className="tg-modal-mobile">
        <button type="button" className="popup-close" onClick={e => closeModal(e, onClose)}>
          <i className="icon-cross" />
        </button>
        <div className="tg-modal-mobile-inner">
          <div className="tg-modal-mobile-img-container">
            <img src={`${STATIC_PATH}/img/tg-popup/tg-mobile.png`} alt="" />
          </div>
          <div className="tg-modal-mobile-text-container">
            <b>
              <FormattedMessage
                id="telegram_popup.title-mobile"
                defaultMessage="Subscribe to our Telegram channel"
              />
            </b>
            <div>
              <a
                href="https://t.me/offerrum_cpa"
                target="_blank"
                className="tg-subscribe-button btn btn-primary not_subscribed"
              >
                <FormattedMessage
                  id="telegram_popup.buttons.subscribe"
                  defaultMessage="Subscribe"
                />
              </a>
            </div>
            <button
              type="button"
              className="tg-subscribed-button btn btn-inline"
              onClick={e => closeModal(e, onAlreadySubscribe)}
            >
              <FormattedMessage
                id="telegram_popup.buttons.already_subscribed"
                defaultMessage="Already subscribed"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ intl }) => ({
  lang: intl.locale,
});

export default connect(mapStateToProps)(ModalTelegramSubscribe);
